import { ChangeEventHandler, FocusEventHandler, KeyboardEventHandler, MouseEvent, MouseEventHandler, Ref } from 'react';

import { SearchIcon } from '@/components/icons';
import { cn } from '@/lib/utils';

interface SearchFieldInputProps {
  id?: string;
  name?: string;
  type?: string;
  value?: string;
  disabled?: boolean;
  className?: string;
  placeholder?: string;
  autoComplete?: string;
  inputRef?: Ref<HTMLInputElement>;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onBlur?: FocusEventHandler<HTMLInputElement>;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
  onMouseDown?: MouseEventHandler<HTMLInputElement>;
  onSearchClick?: (event: MouseEvent<HTMLButtonElement>) => void | Promise<void>;
}

export function SearchFieldInput({
  id,
  name,
  type = 'text',
  value,
  disabled,
  className,
  placeholder,
  autoComplete,
  inputRef,
  onChange,
  onFocus,
  onBlur,
  onKeyDown,
  onMouseDown,
  onSearchClick
}: SearchFieldInputProps) {
  return (
    <div className={cn('relative min-w-40 shrink-0', type === 'number' && 'mt-2', className)}>
      <input
        id={id}
        name={name}
        ref={inputRef}
        type={type}
        disabled={disabled}
        value={value}
        autoComplete={autoComplete}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        onMouseDown={onMouseDown}
        placeholder={placeholder}
        className='h-8 w-full border-0 border-b border-gray-200 bg-transparent px-2 py-1 pr-7 text-sm text-gray-900 outline-none transition-colors placeholder:text-black/60 hover:border-blue-600 focus:border-blue-600 disabled:cursor-not-allowed disabled:text-black/60'
      />
      {!disabled && (
        <button
          type='button'
          onClick={onSearchClick}
          className='absolute right-1 top-1/2 flex -translate-y-1/2 cursor-pointer items-center justify-center p-1 text-gray-500 hover:text-blue-600'
          tabIndex={-1}
        >
          <SearchIcon size={16} color='#2563EB' />
        </button>
      )}
    </div>
  );
}

interface SearchTableFilterInputProps {
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
}

export function SearchTableFilterInput({ value, onChange }: SearchTableFilterInputProps) {
  return (
    <div className='relative ml-2 w-[300px]'>
      <SearchIcon size={14} color='#2563EB' className='absolute left-3 top-1/2 -translate-y-1/2' />
      <input
        value={value}
        onChange={onChange}
        placeholder='Tìm kiếm...'
        className='h-[30px] w-full rounded-none border border-gray-300 bg-white py-1 pl-8 pr-2 text-[0.8rem] leading-[22px] outline-none transition-colors hover:border-gray-400 focus:border-blue-600'
      />
    </div>
  );
}
